/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import styled from "styled-components";

const SeparatorLine = styled.div({
  background: 'gray', paddingTop: 2
})

export default SeparatorLine